// Sorted as we want them to appear
export const CATEGORIES_LIST = [
  "variant",
  "gene",
  "disease",
  "phenotype",
  "article",
  "ClinVar entry",
  "UniProt variant",
  "VarSome PubMed",
  "VarSome comment",
];

export const CATEGORIES = {
  "UniProt variant": {
    single: "UniProt variant",
    plural: "UniProt variants",
  },
  "ClinVar entry": {
    single: "ClinVar entry",
    plural: "ClinVar entries",
  },
  phenotype: {
    single: "phenotype",
    plural: "phenotypes",
  },
  disease: {
    single: "disease",
    plural: "diseases",
  },
  gene: {
    single: "gene",
    plural: "genes",
  },
  article: {
    single: "article",
    plural: "articles",
  },
  variant: {
    single: "variant",
    plural: "variants",
  },
  Variant: {
    single: "variant",
    plural: "variants",
  },
  "VarSome comment": {
    single: "Varsome user classification",
    plural: "Varsome user classifications",
  },
  "VarSome PubMed": {
    single: "Varsome user publication",
    plural: "Varsome user publications",
  },
};
